var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"info_header"},[_c('el-button',{style:({fontSize: '14px'}),attrs:{"type":"text","icon":"el-icon-back"},on:{"click":_vm.closePage}},[_vm._v("返回")]),_c('span',{staticClass:"text pl10 pr10 font14px"},[_vm._v("|")]),_c('span',{staticClass:"text pr10 font14px"},[_vm._v(_vm._s(_vm.title))]),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }